import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Building2, CalendarDays } from 'lucide-react';
import CentrosTab from './CentrosTab';
import CalendarioTab from './CalendarioTab';
import { useAuth } from '../../context/AuthContext';

/**
 * Sección "Centros de trabajo": agrupa Centros y Calendario laboral bajo sub-pestañas.
 * Los festivos están vinculados por centro_id, así que tiene sentido tenerlos juntos.
 */
const CentrosSection = () => {
  const { puede } = useAuth();
  const puedeCalendario = puede('calendario');
  const [tab, setTab] = useState('centros');

  return (
    <div className="space-y-4" data-testid="centros-section">
      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList className="bg-zinc-100 p-1 h-auto inline-flex" data-testid="centros-subtabs">
          <TabsTrigger value="centros" data-testid="subtab-centros"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm">
            <Building2 className="h-4 w-4 mr-2" /> Centros
          </TabsTrigger>
          {puedeCalendario && (
            <TabsTrigger value="calendario" data-testid="subtab-calendario"
              className="data-[state=active]:bg-white data-[state=active]:shadow-sm">
              <CalendarDays className="h-4 w-4 mr-2" /> Calendario laboral
            </TabsTrigger>
          )}
        </TabsList>
        <TabsContent value="centros"><CentrosTab /></TabsContent>
        {puedeCalendario && (
          <TabsContent value="calendario"><CalendarioTab /></TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default CentrosSection;
